import React, { useEffect } from 'react'
import { Switch, Route } from 'react-router'
import { useHistory } from 'react-router-dom'
import { RouterState } from 'connected-react-router'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toast } from '@services'

import {
  RootState,
  Dispatcher,
  AppState
} from 'AppTypes'

import { isJwtTokenExpired } from '@utils/jwt-token'

import { initStoreRegistrationLayout } from '@app/state_management/actions'

import Dashboard from '@features/dashboard/Dashboard'
import StoreManagement from '@features/store_management/StoreManagement'
import Video from '@features/videos/Video'
import LiveStream from '@features/live_stream/LiveStream'
import MenuManagement from '@features/menu_management/MenuManagement'
import Analytics from '@features/analytics/Analytics'

import { LoadingSpinner } from '@share/components'

import PageNotFoundLayout from './404'

import { MainToolbar, LeftSidebar, RightSidebar, Overlay } from './partials'

import './Main.css'

type Props = {
  appState: AppState
  routerState: RouterState
  dispatch: Dispatcher
}

/* eslint no-console: "off" */
/* eslint no-debugger: "off" */
const StoreRegistration: React.FC<Props> = ({
  appState: {
    isStoreRegistrationLayoutInitialed
  },
  routerState: {
    location: {
      pathname: locationPathname
    }
  },
  dispatch
}) => {
  const history = useHistory()
  const { t } = useTranslation()

  if (locationPathname === '/') {
    history.replace('/dashboard')
  }

  useEffect(() => {
    const jwtToken = localStorage.getItem('jwtToken')
    const refreshToken = localStorage.getItem('refreshToken')
    const storeUserId = localStorage.getItem('storeUserId')

    if (!jwtToken || !storeUserId || (isJwtTokenExpired(jwtToken) && !refreshToken)) {
      window.location.replace(`/login?redirectTo=${encodeURIComponent(locationPathname)}`)
    }

    if (locationPathname === '/') {
      history.replace('/dashboard')
    }

    dispatch(initStoreRegistrationLayout()).then(
      () => {},
      reason => {
        console.log('Main layout initialed failed', reason)
        toast.error(t('messages.generalErrorMsg'))
      }
    )
  }, [dispatch])

  if (!isStoreRegistrationLayoutInitialed) {
    return (
      <div className="wrapper">
        <LoadingSpinner isShowing />
      </div>
    )
  }

  return (
    <div id="register">
      <section className="register-block">
        <div className="row no-gutters align-items-center">
          <div className="col-3 text-center register-logo">
            <img src="/assets/img/GMTS_logo.png" alt="" />
          </div>
          <div className="col-9 register-content p-4">
            <h1>GMTS 店舗会員登録申請 STEP 1/3</h1>
            <div className="regis-box">
              <div className="search">
                <label className="lbhead">店名または電話番号で検索</label>
                <div className="form-group row">
                  <div className="col-sm-8">
                    <input className="form-control input-search" type="text" />
                  </div>
                  <div className="col-sm-4 pl-0">
                    <button type="submit" className="btn btn-search">検 索</button>
                  </div>
                </div>
              </div>
              <div className="result-search">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>Happy Bones 浅草橋店</td>
                      <td>03-3861-5235</td>
                      <td>〒東京都台東区鳥越2-7-4</td>
                      <td>
                        <button type="submit" className="btn btn-detail">詳 細</button>
                        <button type="submit" className="btn btn-regis">登録申請</button>
                      </td>
                    </tr>
                    <tr>
                      <td>Happy Bones 浅草橋店</td>
                      <td>03-3861-5235</td>
                      <td>〒東京都台東区鳥越2-7-4</td>
                      <td>
                        <button type="submit" className="btn btn-detail">詳 細</button>
                        <button type="submit" className="btn btn-regis">登録申請</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="regis-box">
              <div className="d-flex align-items-center pt-2 ">
                <label className="lbhead m-0 mr-4">新しい店舗を登録申請</label>
                <button type="submit" className="btn btn-regis">登録申請</button>
              </div>
            </div>
            <div className="regis-box">
              <div className="d-flex align-items-center pt-2 ">
                <label className="lbhead m-0 mr-4 text-right">複数店舗を登録する<br /><span>(Excelデータ)</span></label>
                <button type="submit" className="btn btn-regis">登録申請</button>
                <textarea className="form-control ml-3" rows={3} placeholder="登録の流れ" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default connect((state: RootState) => ({
  appState: state.app,
  routerState: state.router
}))(StoreRegistration)
